import { SolutionPageLayout } from '@/components/solutions/SolutionPageLayout';

const COVERAGE_CARDS = [
  {
    title: 'FNOL & intake',
    description:
      'Athena ingests notices from any channel, digitizes attachments, verifies policy, and opens a complete, structured claim — twice as fast as manual intake.',
  },
  {
    title: 'Triage & assignment',
    description:
      'Every claim classified and routed by complexity and severity — full triage automation, with the Brain balancing workloads across adjuster and agent pools.',
  },
  {
    title: 'Investigation & evaluation',
    description:
      'Agents gather statements, records, and estimates; rules and AI guide the evaluation; everything lands in the claim file with lineage for the adjuster review and decisions.',
  },
  {
    title: 'Resolution & administration',
    description:
      'Low-complexity claims run straight through following rules; payments above threshold park for human approval.',
  },
  {
    title: 'Salvage, subrogation & SIU',
    description:
      'Recovery and fraud signals surfaced automatically and routed to the right specialist with the evidence attached.',
  },
  {
    title: 'Adjuster workbench',
    description:
      'One environment over Guidewire, Duck Creek — the queue, the file, the approvals, and the digital workers, together.',
  },
];

export function ClaimsPage() {
  return (
    <SolutionPageLayout
      title="Claims - CriticalBridge.AI"
      canonicalPath="/claims"
      crumbLabel="Claims"
      heroTitle="Claims, end to end — not task by task."
      heroSub="From FNOL to resolution in one governed flow: digital workers clear intake and triage, straight-through handling resolves the routine, and adjusters decide the complex with every fact in front of them."
      coverage={{
        eyebrow: 'Coverage',
        title: 'The whole claims value chain, on one platform.',
        cards: COVERAGE_CARDS,
      }}
      governance={{
        eyebrow: 'Governance built in',
        title: 'Every claims decision, examiner-ready.',
        body: "Customer-facing decisions carry NAIC evidence fields, bias testing runs on schedule, and any payout above your threshold requires a person's approval — enforced by the platform, not by convention. When the market conduct exam comes, the evidence pack is one click.",
        linkTo: '/lighthouse',
        linkLabel: 'How governance works →',
      }}
    />
  );
}
